import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, MessageCircle, Bell, User, Settings, Heart } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
const Dashboard = () => {
  // Mock data for the current day
  const today = new Date();
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const currentDay = dayNames[today.getDay()];
  const isFriday = currentDay === 'Friday';
  const isReflectionPeriod = currentDay !== 'Friday' && currentDay !== 'Saturday'; // Saturday is the first day after Friday
  // Mock match data
  const currentMatch = {
    name: 'Sarah',
    age: 28,
    education: "Master's in Business Administration",
    profession: 'Marketing Executive',
    avatar: 'https://images.unsplash.com/photo-1583221863654-a2b67f6e8c49?q=80&w=2000&auto=format&fit=crop'
  };
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-87">
      <Header data-id="element-88" />
      <main className="flex-grow py-8 px-4" data-id="element-89">
        <div className="max-w-6xl mx-auto" data-id="element-90">
          {/* Dashboard Header */}
          <div className="bg-gradient-to-r from-emerald-800 to-teal-700 rounded-xl p-6 mb-8 text-white shadow-md" data-id="element-91">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-92">
              <div data-id="element-93">
                <h1 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-94">
                  Welcome, Mohammed
                </h1>
                <p className="text-emerald-100" data-id="element-95">
                  Today is {currentDay},{' '}
                  {today.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
                </p>
              </div>
              <div className="mt-4 md:mt-0 flex items-center" data-id="element-96">
                <div className="flex items-center mr-4" data-id="element-97">
                  <Calendar className="h-5 w-5 mr-2" data-id="element-98" />
                  <span data-id="element-99">Next match: {isFriday ? 'Today' : 'Friday'}</span>
                </div>
                <Link to="/profile-setup" className="bg-white text-emerald-800 hover:bg-emerald-100 font-medium py-2 px-4 rounded-lg transition duration-300 flex items-center" data-id="element-100">
                  <User className="h-4 w-4 mr-2" data-id="element-101" />
                  Profile
                </Link>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-102">
            {/* Main Content Area */}
            <div className="lg:col-span-2 space-y-8" data-id="element-103">
              {/* Current Match Section */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-104">
                <div className="p-6" data-id="element-105">
                  <div className="flex justify-between items-center mb-4" data-id="element-106">
                    <h2 className="text-xl font-bold text-emerald-900" data-id="element-107">
                      {isFriday ? "Today's Match" : isReflectionPeriod ? 'Your Match - Reflection Period' : 'Your Last Match'}
                    </h2>
                    <div className="flex items-center text-amber-600 font-medium" data-id="element-108">
                      <Clock className="h-4 w-4 mr-1" data-id="element-109" />
                      {isFriday ? <span data-id="element-110">Chat open today only</span> : isReflectionPeriod ? <span data-id="element-111">Decision due by Thursday</span> : <span data-id="element-112">New match in {6 - today.getDay()} days</span>}
                    </div>
                  </div>
                  {currentMatch ? <div className="flex flex-col md:flex-row" data-id="element-113">
                      <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-114">
                        <div className="aspect-square rounded-lg overflow-hidden bg-gray-100" data-id="element-115">
                          <img src="https://images.unsplash.com/photo-1609220136736-443140cffec6?q=80&w=2000&auto=format&fit=crop" alt="Profile avatar" className="w-full h-full object-cover" data-id="element-116" />
                        </div>
                        {isFriday && <div className="mt-4" data-id="element-117">
                            <Link to="/match" className="block w-full bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-2 px-4 rounded-lg text-center transition duration-300" data-id="element-118">
                              <MessageCircle className="h-4 w-4 inline-block mr-2" data-id="element-119" />
                              Start Conversation
                            </Link>
                          </div>}
                        {isReflectionPeriod && <div className="mt-4 space-y-2" data-id="element-120">
                            <Link to="/match" className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2 px-4 rounded-lg text-center transition duration-300" data-id="element-121">
                              <MessageCircle className="h-4 w-4 inline-block mr-2" data-id="element-122" />
                              View Conversation
                            </Link>
                            <p className="text-xs text-center text-gray-500" data-id="element-123">
                              Chat locked until next Friday
                            </p>
                          </div>}
                      </div>
                      <div className="md:w-2/3 md:pl-6" data-id="element-124">
                        <div className="flex justify-between items-start mb-3" data-id="element-125">
                          <h3 className="text-xl font-bold text-gray-900" data-id="element-126">
                            {currentMatch.name}, {currentMatch.age}
                          </h3>
                          <span className="bg-emerald-100 text-emerald-800 text-xs px-2 py-1 rounded-full font-medium" data-id="element-127">
                            Verified Emirati
                          </span>
                        </div>
                        <div className="space-y-3" data-id="element-128">
                          <div data-id="element-129">
                            <p className="text-sm font-medium text-gray-500" data-id="element-130">
                              Education
                            </p>
                            <p className="text-gray-800" data-id="element-131">
                              {currentMatch.education}
                            </p>
                          </div>
                          <div data-id="element-132">
                            <p className="text-sm font-medium text-gray-500" data-id="element-133">
                              Profession
                            </p>
                            <p className="text-gray-800" data-id="element-134">
                              {currentMatch.profession}
                            </p>
                          </div>
                          <div data-id="element-135">
                            <p className="text-sm font-medium text-gray-500" data-id="element-136">
                              About
                            </p>
                            <p className="text-gray-800" data-id="element-137">
                              I'm passionate about business, travel, and
                              maintaining a healthy lifestyle. Looking for
                              someone who values family and has ambitions for
                              the future.
                            </p>
                          </div>
                        </div>
                        {isReflectionPeriod && <div className="mt-6" data-id="element-138">
                            <div className="bg-amber-50 p-4 rounded-lg mb-4" data-id="element-139">
                              <p className="text-sm text-amber-800" data-id="element-140">
                                <strong data-id="element-141">Reflection Period:</strong> Review your
                                Friday conversation and decide if you'd like to
                                proceed with a Khitbah request.
                              </p>
                            </div>
                            <div className="flex space-x-3" data-id="element-142">
                              <button className="flex-1 bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-2 px-4 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-143">
                                <Heart className="h-4 w-4 mr-2" data-id="element-144" />
                                Send Khitbah Request
                              </button>
                              <button className="flex-1 border border-gray-300 hover:bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg transition duration-300" data-id="element-145">
                                Decline Match
                              </button>
                            </div>
                          </div>}
                      </div>
                    </div> : <div className="text-center py-8" data-id="element-146">
                      <p className="text-gray-500 mb-4" data-id="element-147">
                        No active matches at the moment.
                      </p>
                      <p className="text-gray-700" data-id="element-148">
                        Your next match will be available on Friday.
                      </p>
                    </div>}
                </div>
                <div className="bg-amber-50 p-4 border-t border-amber-100" data-id="element-149">
                  <div className="flex items-center mb-2" data-id="element-150">
                    <Calendar className="h-5 w-5 text-amber-600 mr-2" data-id="element-151" />
                    <p className="text-amber-800 text-sm" data-id="element-152">
                      <span className="font-medium" data-id="element-153">Friday:</span> Chat window
                      opens - Connect with your match
                    </p>
                  </div>
                  <div className="flex items-center" data-id="element-154">
                    <Clock className="h-5 w-5 text-amber-600 mr-2" data-id="element-155" />
                    <p className="text-amber-800 text-sm" data-id="element-156">
                      <span className="font-medium" data-id="element-157">Saturday - Thursday:</span>{' '}
                      Reflection period - Review conversation and make your
                      decision
                    </p>
                  </div>
                </div>
              </div>
              {/* Guardian Mode Section */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-158">
                <div className="p-6" data-id="element-159">
                  <h2 className="text-xl font-bold text-emerald-900 mb-4" data-id="element-160">
                    Guardian Mode
                  </h2>
                  <div className="bg-emerald-50 p-4 rounded-lg mb-6" data-id="element-161">
                    <p className="text-emerald-800" data-id="element-162">
                      Guardian Mode allows you to include family members in your
                      marriage search journey when you're ready.
                    </p>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-163">
                    <div className="border border-gray-200 rounded-lg p-4 hover:border-emerald-300 transition duration-300 cursor-pointer" data-id="element-164">
                      <h3 className="font-medium text-gray-900 mb-2" data-id="element-165">
                        Invite a Family Guardian
                      </h3>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-166">
                        Invite a parent or family member to oversee your
                        conversations and matches.
                      </p>
                      <button className="text-emerald-700 font-medium text-sm hover:text-emerald-800 transition duration-300" data-id="element-167">
                        Send Invitation →
                      </button>
                    </div>
                    <div className="border border-gray-200 rounded-lg p-4 hover:border-emerald-300 transition duration-300 cursor-pointer" data-id="element-168">
                      <h3 className="font-medium text-gray-900 mb-2" data-id="element-169">
                        Family Chat Mode
                      </h3>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-170">
                        Create a group conversation with your match and both
                        families.
                      </p>
                      <button className="text-emerald-700 font-medium text-sm hover:text-emerald-800 transition duration-300" data-id="element-171">
                        Set Up Family Chat →
                      </button>
                    </div>
                  </div>
                  <div className="mt-4 text-center" data-id="element-172">
                    <Link to="/guardian" className="text-emerald-700 font-medium hover:text-emerald-800 transition duration-300" data-id="element-173">
                      Learn more about Guardian Mode
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <div className="space-y-8" data-id="element-174">
              {/* Profile Card */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-175">
                <div className="p-6" data-id="element-176">
                  <div className="flex items-center justify-between mb-4" data-id="element-177">
                    <h2 className="text-xl font-bold text-emerald-900" data-id="element-178">
                      Your Profile
                    </h2>
                    <Link to="/profile-setup" className="text-emerald-700 hover:text-emerald-800" data-id="element-179">
                      <Settings className="h-5 w-5" data-id="element-180" />
                    </Link>
                  </div>
                  <div className="flex items-center mb-6" data-id="element-181">
                    <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mr-4" data-id="element-182">
                      <User className="h-8 w-8 text-emerald-700" data-id="element-183" />
                    </div>
                    <div data-id="element-184">
                      <h3 className="text-lg font-bold text-gray-900" data-id="element-185">
                        Mohammed, 32
                      </h3>
                      <span className="bg-emerald-100 text-emerald-800 text-xs px-2 py-1 rounded-full font-medium" data-id="element-186">
                        Verified Emirati
                      </span>
                    </div>
                  </div>
                  <div className="space-y-4" data-id="element-187">
                    <div data-id="element-188">
                      <p className="text-sm font-medium text-gray-500" data-id="element-189">
                        Profile Completion
                      </p>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1" data-id="element-190">
                        <div className="bg-emerald-600 h-2.5 rounded-full" style={{
                        width: '85%'
                      }} data-id="element-191"></div>
                      </div>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-192">85% complete</p>
                    </div>
                    <div data-id="element-193">
                      <p className="text-sm font-medium text-gray-500" data-id="element-194">
                        Privacy Settings
                      </p>
                      <p className="text-gray-800" data-id="element-195">Using default avatar</p>
                    </div>
                    <div data-id="element-196">
                      <p className="text-sm font-medium text-gray-500" data-id="element-197">
                        Guardian Mode
                      </p>
                      <p className="text-gray-800" data-id="element-198">Optional (not active)</p>
                    </div>
                  </div>
                  <div className="mt-6" data-id="element-199">
                    <Link to="/profile-setup" className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg text-center transition duration-300" data-id="element-200">
                      Complete Your Profile
                    </Link>
                  </div>
                </div>
              </div>
              {/* Upcoming Events */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-201">
                <div className="p-6" data-id="element-202">
                  <h2 className="text-xl font-bold text-emerald-900 mb-4" data-id="element-203">
                    Calendar
                  </h2>
                  <div className="space-y-4" data-id="element-204">
                    <div className={`p-3 rounded-lg ${isFriday ? 'bg-emerald-100 border border-emerald-200' : 'bg-gray-100'}`} data-id="element-205">
                      <div className="flex items-center" data-id="element-206">
                        <Calendar className={`h-5 w-5 mr-2 ${isFriday ? 'text-emerald-700' : 'text-gray-600'}`} data-id="element-207" />
                        <h3 className={`font-medium ${isFriday ? 'text-emerald-900' : 'text-gray-800'}`} data-id="element-208">
                          Friday - Match Day
                        </h3>
                      </div>
                      <p className={`text-sm mt-1 ${isFriday ? 'text-emerald-700' : 'text-gray-600'}`} data-id="element-209">
                        {isFriday ? 'Today! Check your new match' : 'Your next match will arrive on Friday'}
                      </p>
                    </div>
                    <div className={`p-3 rounded-lg ${!isFriday ? 'bg-amber-100 border border-amber-200' : 'bg-gray-100'}`} data-id="element-210">
                      <div className="flex items-center" data-id="element-211">
                        <Clock className={`h-5 w-5 mr-2 ${!isFriday ? 'text-amber-700' : 'text-gray-600'}`} data-id="element-212" />
                        <h3 className={`font-medium ${!isFriday ? 'text-amber-900' : 'text-gray-800'}`} data-id="element-213">
                          Reflection Period
                        </h3>
                      </div>
                      <p className={`text-sm mt-1 ${!isFriday ? 'text-amber-700' : 'text-gray-600'}`} data-id="element-214">
                        {!isFriday ? 'Time to consider your match' : 'Begins on Saturday'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Notifications */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-215">
                <div className="p-6" data-id="element-216">
                  <div className="flex items-center justify-between mb-4" data-id="element-217">
                    <h2 className="text-xl font-bold text-emerald-900" data-id="element-218">
                      Notifications
                    </h2>
                    <span className="bg-emerald-100 text-emerald-800 text-xs px-2 py-1 rounded-full" data-id="element-219">
                      2 New
                    </span>
                  </div>
                  <div className="space-y-3" data-id="element-220">
                    <div className="p-3 bg-amber-50 rounded-lg" data-id="element-221">
                      <div className="flex items-start" data-id="element-222">
                        <Bell className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-223" />
                        <div data-id="element-224">
                          <p className="text-gray-800 font-medium" data-id="element-225">
                            Profile Verification Complete
                          </p>
                          <p className="text-sm text-gray-600 mt-1" data-id="element-226">
                            Your Emirati status has been verified successfully.
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-227">
                            2 hours ago
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 bg-gray-50 rounded-lg" data-id="element-228">
                      <div className="flex items-start" data-id="element-229">
                        <Calendar className="h-5 w-5 text-gray-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-230" />
                        <div data-id="element-231">
                          <p className="text-gray-800 font-medium" data-id="element-232">
                            Match Day Reminder
                          </p>
                          <p className="text-sm text-gray-600 mt-1" data-id="element-233">
                            Tomorrow is Friday! Prepare for your new match.
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-234">
                            1 day ago
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 text-center" data-id="element-235">
                    <button className="text-emerald-700 font-medium hover:text-emerald-800 transition duration-300" data-id="element-236">
                      View All Notifications
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-237" />
    </div>;
};
export default Dashboard;